// Module
var code = "<section class=\"cr-weekday-viewer cr-flex-between {{ ::$ctrl.customClass }}\" ng-class=\"::{'small-view': $ctrl.smallView}\"> <div ng-repeat=\"weekday in ::$ctrl.weekdays\" class=\"day\" ng-class=\"::{selected: $ctrl.isSelected(weekday)}\" data-local-qa-id=\"day\"> {{ $ctrl.text[weekday] }} </div> </section> ";
// Exports
export default code;